import { Modal, Fade, Backdrop, Card, Icon, Tooltip, Slide, Grid, InputLabel, CircularProgress } from "@mui/material";
import PropTypes from "prop-types";
// Kaizen Dashboard components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";
import { MessageManager } from "context";
import { useCallback, useContext, useEffect, useState } from "react";
import { gql, useMutation } from "@apollo/client";
import { UserContext } from "context/user";
import SoftInput from "components/SoftInput";

import Proveedores from "layouts/authentication/proveedores";



const ADD_PROVEEDOR = gql`
  mutation addProveedor($input: ProveedorInput!) {
    saveProveedor(input: $input) {
      id
    }
  }
`;

export default function ModalCompletarDatos({ open, handleClose, refetchParent, proveedorId, tipoDocumento, documento, telefono }) {
  const { handleSnackbar } = useContext(MessageManager);
  const { user } = useContext(UserContext);
  const [data, setData] = useState({});
  const [addProveedor, { loading: loadingSave }] = useMutation(ADD_PROVEEDOR);
  const mostrarCampoDocumento = !document || documento?.length < 11;
  const mostrarTelefono = !telefono || telefono?.length < 10;
  const camposVisibles = [mostrarTelefono, mostrarCampoDocumento].filter(Boolean).length;

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxHeight: "90%",
    width:
      camposVisibles === 1
        ? { xs: "90%", sm: "70%", md: "60%", lg: "40%", xl: "20%" }
        : { xs: "90%", sm: "75%", md: "70%", lg: "50%", xl: "30%" },
    py: 3,
    px: 3,
    overflow: "auto",
  };

  useEffect(() => {
    if (mostrarCampoDocumento) {
      setData((prevData) => ({
        ...prevData,
        tipoDocumento: 80, // fuerza tipo 80 si el doc es corto
      }));
    }
  }, [mostrarCampoDocumento]);


  const handleChanges = (e) => {
    const { name, value } = e.target;
    validateTelefono(name, value);
    setData({
      ...data,
      [name]: value,
    });
  };

  const handleSave = () => {
    const input = { ...data, id: proveedorId };

    if (mostrarCampoDocumento) {
      if (!input.documento || input.documento.length !== 11) {
        handleSnackbar("Debe ingresar un CUIT válido de 11 dígitos", "warning");
        return;
      }
    }

    if (mostrarTelefono) {
      if (!validateTelefono(input.telefono)) {
        handleSnackbar("Debe ingresar un teléfono válido de al menos 10 dígitos", "warning");
        return;
      }
    }


    addProveedor({ variables: { input } })
      .then(() => {
        handleSnackbar("Datos actualizados correctamente", "success");
        refetchParent();
        handleClose();
      })
      .catch((error) => {
        handleSnackbar(error.message, "error");
      });
  };



  const validateTelefono = (telefono) => {
    return telefono && /^\d{10,}$/.test(telefono.trim());
  };
  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 500 }}
    >
      <Fade in={open}>
        <Card sx={style}>
          <SoftBox display="flex" justifyContent="space-between" alignItems="center">
            <SoftBox display="flex" alignItems="center" gap={1}>
              <SoftTypography variant="h5" fontWeight="bold">
                🚀
              </SoftTypography>
              <SoftTypography variant="h6" fontWeight="bold">
                Completa tus datos
              </SoftTypography>
            </SoftBox>
          </SoftBox>
          <SoftBox lineHeight={1}>
            <SoftTypography variant="caption" color="secondary" lineHeight={1}>
              Para poder continuar, requerimos que actualices tus datos.
            </SoftTypography>
          </SoftBox>
          <Grid container spacing={2} mt={1}>
            {mostrarTelefono && (
              <Grid item xs={12} lg={12}>
                <InputLabel htmlFor="telefono">
                  <SoftTypography component="label" variant="caption" fontWeight="bold">
                    Teléfono
                  </SoftTypography>
                </InputLabel>
                <SoftInput
                  label="Telefono"
                  placeholder="Ingrese su telefono"
                  type="text"
                  name="telefono"
                  value={data.telefono || ""}
                  onChange={handleChanges}
                />
              </Grid>
            )}
            {mostrarCampoDocumento && (
              <Grid item xs={12} lg={12}>
                <InputLabel htmlFor="documento">
                  <SoftTypography component="label" variant="caption" fontWeight="bold">
                    CUIT (11 dígitos)
                  </SoftTypography>
                </InputLabel>
                <SoftInput
                  label="CUIT"
                  placeholder="Ingrese su CUIT"
                  type="text"
                  name="documento"
                  value={data.documento || ""}
                  onChange={handleChanges}
                />
              </Grid>
            )}
          </Grid>
          <SoftBox display="flex" justifyContent="flex-end" gap={1} mt={2}>
            <SoftButton
              variant="contained"
              color="primary"
              circular
              disabled={
                loadingSave ||
                (mostrarTelefono && !validateTelefono(data.telefono)) ||
                (mostrarCampoDocumento && (!data.documento || data.documento.length !== 11))
              }

              onClick={handleSave}
            >
              {loadingSave ? (
                <CircularProgress size={17} color="white" sx={{ mx: 5 }} />
              ) : (
                <div style={{ display: "flex", alignItems: "center" }}>
                  Actualizar <SoftTypography variant="h6" my={-1}>👌</SoftTypography>
                </div>
              )}
            </SoftButton>
          </SoftBox>
        </Card>
      </Fade>
    </Modal>
  );
}

ModalCompletarDatos.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  refetchParent: PropTypes.func,
  proveedorId: PropTypes.string,
  documento: PropTypes.string,
  tipoDocumento: PropTypes.number,
  telefono: PropTypes.string,
};
